import { Component } from '@angular/core';

@Component({
  selector: 'app-global-loading',
  standalone: true,
  templateUrl: './global-loading.component.html',
})
export class GlobalLoadingComponent {}
